import { useEffect, useState } from 'react';
import { Switch, Redirect } from 'react-router-dom';

import routes from '../route';
import routeList from 'shared/constants/routes';
import errorRoute from 'screens/Error/route';

import { RouteWithSubRoutes, LazyLoader } from 'shared/components';
import Header from './Header';
import Footer from './Footer';

function App() {
  const [renderRoutes, changeRenderRoutes] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      changeRenderRoutes(true);
    }, 2000);

    (function () {
      let s1 = document.createElement('script'),
        s0 = document.getElementsByTagName('script')[0];
      s1.async = true;
      s1.src = 'https://embed.tawk.to/61233c7dd6e7610a49b17a56/1fdoq8iqf';
      s1.setAttribute('crossorigin', '*');
      s0.parentNode.insertBefore(s1, s0);
    })();
  }, []);

  return !renderRoutes ? (
    <LazyLoader />
  ) : (
    <>
      <Header />
      <Switch>
        <Redirect exact from="/" to={routeList.HOME.path} />
        {routes.map((route, i) => (
          <RouteWithSubRoutes key={i} {...route} />
        ))}
        <Redirect to={errorRoute.path} />
      </Switch>
      <Footer />
    </>
  );
}

export default App;
